// assets/lenis.js
import Lenis from "https://cdn.jsdelivr.net/npm/lenis@1.1.16/+esm";
import gsap from "https://cdn.jsdelivr.net/npm/gsap@3.12.5/+esm";
import { ScrollTrigger } from "https://cdn.jsdelivr.net/npm/gsap@3.12.5/ScrollTrigger/+esm";
console.log("LENIS LOADED");
window.gsap = gsap;
window.ScrollTrigger = ScrollTrigger;
gsap.registerPlugin(ScrollTrigger);
var lenis = new Lenis({
  lerp: 0.1,
  // Smoothness of scroll
  smoothWheel: true,
  gestureOrientation: "vertical",
  prevent: (node) => node.classList.contains("nested") || node.classList.contains("no-scroll")
});
window.lenis = lenis;
lenis.on("scroll", window.ScrollTrigger.update);
gsap.ticker.add((t) => {
  lenis.raf(t * 1e3);
});
gsap.ticker.lagSmoothing(0);
console.log("LENIS INITIALIZED");
